import { render } from "./FormatListNumbered.vue?vue&type=template&id=83d2f80e"
import script from "./FormatListNumbered.vue?vue&type=script&lang=js"
export * from "./FormatListNumbered.vue?vue&type=script&lang=js"

import exportComponent from "../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"@apostrophecms/vue-material-design-icons/FormatListNumbered.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "83d2f80e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('83d2f80e', __exports__)) {
    api.reload('83d2f80e', __exports__)
  }
  
  module.hot.accept("./FormatListNumbered.vue?vue&type=template&id=83d2f80e", () => {
    api.rerender('83d2f80e', render)
  })

}


export default __exports__